import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { marked } from 'marked';
import { HiMiniChatBubbleLeftRight } from "react-icons/hi2";
//import { getOrCreateSessionId } from "./utils/session";
//import user_image from './assets/images/user_image.png'
//import bot_image from './assets/images/mundl_logo.jpeg'
//import mara from './assets/images/mara.png'

function getOrCreateSessionId() {
    let id = localStorage.getItem("session_id");
    if (!id) {
        id = (window.crypto && crypto.randomUUID)
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(16).slice(2)}`; // fallback
        localStorage.setItem("session_id", id);
    }
    return id;
}

const Chatbot = () => {
    const initialMessage = {
        sender: 'bot',
        text: `Hallo, wie kann ich Ihnen helfen? 
              <br> Ich interessiere mich für...
              <br>
              <ul style="list-style-type: square; padding-left: 0.5rem;">
                <li>KI-Lösungen</li>
                <li>High-Level Projekte</li>
                <li>Kundenbeziehungen und Zielmärkte</li>
                <li>IAM - Identity and Access Management</li>
                <li>Regionales Marktmonitoring</li>
                <li>ZOHO-Lösungen als sofort einsetzbare Komplettlösung ohne IT</li>
                <li>Standortmanagement und Mehr</li>
                <li>Target Matrix - Adressierbares Marktpotential</li>
                <li>Industrial Internet of Things (IIoT) Lösungen</li>
                <li>Qualitätsmanagement - ein entscheidender Wettbewerbsvorteil</li>
                <li>Innovationsberatung</li>
                <li>Sensor Integration & Data Monitoring</li>
              </ul>
              <br> Ihre Mara ML
`
    };

    const mara = `https://mara.mundl.tech/mara.png`
    const user_image = `https://mara.mundl.tech/user_image.png`

    const [messages, setMessages] = useState([initialMessage]);
    const [userInput, setUserInput] = useState('');
    const [isChatVisible, setIsChatVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [showMenuChat, setShowMenuChat] = useState(false);
    const messagesEndRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitel] = useState("Hallo, ich bin Mara ML. Wie kann ich Ihnen helfen?");
    const [count, setCount] = useState(0)
    const [showTooltip, setShowTooltip] = useState(false);
    const inputRef = useRef(null);
    const [sessionID, setSessionID] = useState('');


    useEffect(() => {
        const id = getOrCreateSessionId();
        setSessionID(id);
    }, []);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (isLoading) return;


        if (count >= 12) {
            setMessages(messages => [...messages, {
                sender: 'bot', text: `Kommen Sie bei Fragen gerne auf uns zu:
            <br/><br/>Wir freuen uns auf den persönlichen Kontakt mit Ihnen.
            <br/><br/><strong>M&L Aktiengesellschaft</strong>
            <br/><strong>Schwarzwaldstrasse 122</strong>
            <br/><strong>60528 Frankfurt am Main</strong>
            <br/>
            <br/><a href="tel:+49699636320">T: +49 (0)69 963 632 - 0</a>
            <br/><a href="tel:+496996363210">F: +49 (0)69 963 632 - 10</a>
            <br/><a  href="mailto:kontakt@mlconsult.com">kontakt@mlconsult.com</a>         
`
            }]);
            return;
        }


        const message = userInput.trim();
        if (!message) return;

        setTitel("Mara ML")
        setMessages((messages) => [...messages, { sender: 'user', text: message }]);
        setUserInput('');
        setIsLoading(true);
        inputRef.current.blur();

        try {
            const config = {
                headers: {
                    'Authorization': 'Bearer TSZMIENvcnBvcmF0ZSBHcm91cCwgQUcsIFN5c3RlbXMsIA==',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.post('https://mara.mundl.tech/api/chat/',
                //const response = await axios.post('http://127.0.0.1:8080/chat/',
                {
                    prompt: message,
                    session_id: sessionID || getOrCreateSessionId(),
                },
                config);

            /* if (response.data.session_id && response.data.session_id !== sessionID) {
                localStorage.setItem("session_id", response.data.session_id);
                setSessionID(response.data.session_id);
            } */

            setMessages((messages) => [...messages, { sender: 'bot', text: response.data.response }]);
            setCount((c) => c + 1);
        } catch (error) {
            console.error('Error:', error);
            setMessages((messages) => [...messages, { sender: 'bot', text: "Aktuell konnte ich keine Daten empfangen. Bitte probieren Sie es später nochmal.<br><br> Ihre Mara ML" }]);
            setCount((c) => c + 1);
        } finally {
            setIsLoading(false);
        }
    };

    // (Optional) bouton “Neue Unterhaltung”
 /*  const newConversation = () => {
    const id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem("session_id", id);
    setSessionID(id);
    setMessages([initialMessage]);
    setCount(0);
  }; */

    const createMarkup = (markdownText) => {
        return { __html: marked(markdownText) };
    };

    useEffect(() => {
        const checkDevice = () => {
            setIsMobile(window.matchMedia('(max-width: 768px)').matches);
        };
        checkDevice();
        window.addEventListener('resize', checkDevice);
        return () => {
            window.removeEventListener('resize', checkDevice);
        };
    }, []);

    const handleShowMenu = () => {
        if (isMobile) {
            setShowMenuChat(false);
        }
    }
    return (
        <div className={`mundl100 tw-fixed tw-bottom-0 tw-right-0 tw-mb-4 tw-mr-4 ${isChatVisible ? 'lg:tw-max-w-6xl' : 'tw-max-w-md'} tw-z-20`}>
            {!isChatVisible && (
                <>
                    {isMobile ? (
                        <>
                            {!showMenuChat ? (
                                <HiMiniChatBubbleLeftRight className="" style={{ width: '90px', height: '90px', color: '#0000A2', stroke: '#2edfba', strokeWidth: 0.5 }}
                                    onClick={() => setShowMenuChat(true)}
                                />
                            )
                                : (<ChatMenu handleShowMenu={handleShowMenu} setIsChatVisible={setIsChatVisible} mara={mara} />)
                            }
                        </>
                    ) : (
                        <ChatMenu handleShowMenu={handleShowMenu} setIsChatVisible={setIsChatVisible} mara={mara} />
                    )}
                </>
            )}
            {isChatVisible && (
                <div className="mundl105 tw-flex tw-w-full lg:tw-max-w-6xl tw-overflow-hidden">
                    <div className="mundl106 tw-hidden md:tw-block tw-w-1/3 tw-h-1/3">
                        <img src={mara} alt="Mara ML" className="imgmara101 tw-rounded-l-xl  tw-object-cover tw-h-full tw-border-4 tw-border-[#2edfba]" />
                    </div>
                    <div className="mundl107 tw-card tw-w-full tw-shadow-lg tw-rounded-r-xl tw-max-w-2xl">
                        <div
                            className="mundl108 tw-flex tw-justify-between tw-items-center tw-h-20"

                        >
                            <div className="mundl109 tw-w-full tw-h-full tw-text-white tw-text-xl tw-p-2 tw-flex tw-justify-start tw-items-center tw-text-center"
                                style={{ backgroundColor: '#2edfba', fontFamily: 'sans-serif' }}
                            >
                                {title}
                            </div>
                            <button
                                className="mundl110 tw-text-white tw-text-xl tw-h-full tw-w-14 tw-p-2 tw-flex tw-justify-center tw-items-center tw-border-2 tw-border-[#2edfba] tw-text-center"
                                onClick={() => setIsChatVisible(false)}
                                style={{ backgroundColor: '#0000A2', fontFamily: 'sans-serif' }}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="mundl111 tw-card-body tw-overflow-y-auto tw-p-3 tw-h-[375px] xl:tw-h-[375px] 2xl:tw-h-[600px] tw-bg-white">
                            {messages.map((message, index) => (
                                <>
                                    <div key={index} className={`mundl112 tw-flex tw-items-start tw-pb-2 ${message.sender === 'user' ? 'tw-justify-end' : 'tw-justify-start'}`}>
                                        {message.sender === 'bot' && <img src={mara} alt="Bot" className="mundl113 tw-rounded-full tw-h-10 tw-w-10 tw-mr-2 tw-object-cover" />}
                                        <span className={`mundl114 tw-inline-block tw-w-full tw-break-words tw-text-xl tw-rounded-lg tw-px-4 tw-py-2 tw-my-1 ${message.sender === 'user' ? 'tw-text-gray-800 tw-text-left' : 'tw-text-[#0000A2] tw-text-left'}`}
                                            dangerouslySetInnerHTML={createMarkup(message.text)}
                                            style={{ backgroundColor: message.sender === 'user' ? '#E5E7EB' : '#FFFFFF', fontFamily: 'sans-serif' }}
                                        />
                                        <br />
                                        {message.sender === 'user' && <img src={user_image} alt="User" className="mundl115 tw-rounded-full tw-h-8 tw-w-8 tw-ml-2" />}
                                    </div>
                                </>
                            ))}
                            <div ref={messagesEndRef} />
                        </div>
                        <div className="mundl116 tw-card-footer tw-bg-white tw-pb-3 tw-pl-3 tw-pr-3">

                            <form onSubmit={handleSendMessage} className="mundl117 tw-flex">
                                <input
                                    ref={inputRef}
                                    type="text"
                                    className="mundl118 tw-shadow tw-appearance-none  tw-flex-1 tw-border tw-border-gray-300 tw-mr-3 tw-rounded tw-py-2 tw-px-4 tw-text-xl tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline focus:tw-border-[#0000A2]"
                                    value={userInput}
                                    onChange={(e) => setUserInput(e.target.value.slice(0, 200))}
                                    onFocus={() => setShowTooltip(true)}
                                    onBlur={() => setShowTooltip(false)}
                                    maxLength="200"
                                    placeholder="Tippen Sie hier Ihre Nachricht ein..."
                                    style={{ fontFamily: 'sans-serif' }}
                                />
                                <button
                                    type="submit"
                                    className="mundl119 tw-font-bold tw-py-2 tw-px-4 tw-text-xl tw-rounded-full tw-h-14 tw-w-28 tw-flex tw-items-center tw-justify-center"
                                    style={{ backgroundColor: '#0000A2', color: 'white', fontFamily: 'sans-serif' }}
                                    disabled={isLoading}
                                >
                                    Send
                                </button>
                                {showTooltip && <div className={`tw-text-xl ${userInput.length === 200 ? 'tw-text-red-950' : 'tw-text-[#0000A2]'}`} style={{ position: 'absolute', marginTop: '-30px', fontFamily: 'sans-serif' }}>{`${userInput.length}/200`}</div>}
                            </form>
                            {isLoading && <div className="mundl120 tw-flex tw-flex-col tw-justify-center tw-items-center tw-mt-2">
                                <div className="mundl121 tw-flex tw-justify-center tw-items-center">
                                    <div
                                        className="mundl122 tw-spinner-border tw-animate-spin tw-inline-block tw-w-8 tw-h-8 tw-border-4 tw-rounded-full"
                                        style={{ borderColor: '#0000A2' }}
                                        role="status">
                                        <span className="mundl123 tw-hidden">Loading...</span>
                                    </div>
                                </div>
                                <p className="mundl124 tw-text-xl tw-ml-2" style={{ fontFamily: 'sans-serif' }}>Bitte haben Sie ein bisschen Geduld...</p>
                            </div>}
                        </div>
                    </div>
                </div>)}
        </div>
    );
};

export default Chatbot;


const ChatMenu = ({ handleShowMenu, setIsChatVisible, mara }) => {
    return (
        <div className="mundl101 tw-flex tw-flex-col tw-items-center tw-justify-center">
            <div className="mundl102 tw-text-white tw-text-xl tw-font-bold tw-py-3 tw-px-4 tw-rounded-t-lg tw-w-44 lg:tw-w-72 tw-text-center tw-shadow-lg"
                style={{ backgroundColor: '#2edfba', fontFamily: 'sans-serif' }}
                onClick={handleShowMenu}
            >
                Hallo, ich bin Mara ML. <br />Wie kann ich Ihnen helfen?
            </div>
            <img src={mara} alt="Chatbot" className="mundl103 tw-w-44 tw-h-44 lg:tw-w-72 lg:tw-h-72 tw-object-cover tw-rounded-b-lg"
                onClick={handleShowMenu}
            />
            <button
                className="mundl104 tw-mt-4 tw-mb-4 tw-text-white tw-text-xl tw-font-bold tw-py-2 tw-px-4 tw-w-44 tw-h-14 tw-flex tw-items-center tw-justify-center tw-border-2 tw-border-neutral-100 tw-shadow-md hover:tw-bg-blue-700 tw-transition-all"
                onClick={() => setIsChatVisible(true)}
                style={{ backgroundColor: '#0000A2', fontFamily: 'sans-serif' }}
            >
                Chat
            </button>
            <button
                className="mundl1055 tw-mb-8 tw-text-white tw-text-xl tw-font-bold tw-py-2 tw-px-4 tw-w-44 tw-h-14 tw-flex tw-items-center tw-justify-center tw-border-2 tw-border-neutral-100 tw-shadow-md hover:tw-bg-green-500 tw-transition-all"
                onClick={() => window.open('https://www.mlconsult.com/kontakt.html', '_self')}
                style={{ backgroundColor: '#2edfba', fontFamily: 'sans-serif' }}
            >
                <span className="tw-mr-2">📧</span>
                Kontakt
            </button>
        </div>
    );
}
